var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "BlockForm",
        _vm._b(
          {
            attrs: { "existing-number": _vm.cachedNumber },
            on: {
              submit: _vm.blockNumberSubmit,
              cacheFormData: _vm.cacheFormData,
              closeForm: function($event) {
                return _vm.$emit("closeForm")
              }
            }
          },
          "BlockForm",
          _vm.$props,
          false
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }